/**
 * @file useApplicationLink.ts
 *
 * @fileoverview Provides logic to create the application link based on the application workflow of the job.
 */

import { Job } from '~/jobiqo/types/types';
import Router from 'next/router';

/*
 * Returns the application link.
 *
 * Depending on the application workflow of the job this hook returns the needed application link.
 */
export const useApplicationLink = (job: Job): string => {
  const prefix = job.absoluteUrl
    ? new URL(job.absoluteUrl).origin
    : Router && Router.locales && Router.locales?.length > 1
    ? `/${Router.locale}`
    : '';

  const applicationLink =
    job.applicationWorkflow === 'internal'
      ? `${Router.basePath}${prefix}/job/apply/${job.id}`
      : job.applicationLink
      ? job.applicationLink
      : // Fallback if no external application link was set.
        `${Router.basePath}${prefix}/job/apply/${job.id}`;
  return applicationLink;
};
